function getSpeakerInfoId(speakerInfo){
    return speakerInfo && speakerInfo.getSpeakerId ? speakerInfo.getSpeakerId() : null;
}

const SelectionSpeakerChangeHelper = {
    isVisibleSequencerNodeEligibleForSpeakerChange : function(sequencerNode, options){
        const normalizedOptions = options || {};
        return !!(
            sequencerNode
            && (
                (normalizedOptions.isWordSequencerNode && normalizedOptions.isWordSequencerNode(sequencerNode))
                || (normalizedOptions.isPauseSequencerNode && normalizedOptions.isPauseSequencerNode(sequencerNode))
                || (normalizedOptions.isAudioEventSequencerNode && normalizedOptions.isAudioEventSequencerNode(sequencerNode))
                || (normalizedOptions.isDeletedSequencerNode && normalizedOptions.isDeletedSequencerNode(sequencerNode))
            )
        );
    },

    getEffectiveSpeakerInfoForSequencerNode : function(sequencerNode, options){
        const explicitSpeakerInfo = sequencerNode && sequencerNode.getSpeakerInfo ? sequencerNode.getSpeakerInfo() : null;
        if(explicitSpeakerInfo){
            return explicitSpeakerInfo;
        }

        const normalizedOptions = options || {};
        const paragraphContainerView = normalizedOptions.getParagraphContainerView ? normalizedOptions.getParagraphContainerView(sequencerNode) : null;
        if(
            paragraphContainerView
            && normalizedOptions.isSpeakerParagraphContainerView
            && normalizedOptions.isSpeakerParagraphContainerView(paragraphContainerView)
            && paragraphContainerView.getModel
        ){
            return paragraphContainerView.getModel();
        }

        return null;
    },

    getUniformEffectiveSpeakerInfoForSequencerNodes : function(arrayOfSequencerNodes, options){
        const normalizedOptions = options || {};
        const normalizedSequencerNodes = arrayOfSequencerNodes || [];
        let uniformSpeakerInfo;
        let uniformSpeakerInfoId;
        let speakerInfoInitialized = false;

        for(let i = 0; i < normalizedSequencerNodes.length; i++){
            const speakerInfo = this.getEffectiveSpeakerInfoForSequencerNode(normalizedSequencerNodes[i], normalizedOptions);
            if(!speakerInfo){
                return null;
            }
            const speakerInfoId = (normalizedOptions.getSpeakerInfoId || getSpeakerInfoId)(speakerInfo);
            if(!speakerInfoInitialized){
                uniformSpeakerInfo = speakerInfo;
                uniformSpeakerInfoId = speakerInfoId;
                speakerInfoInitialized = true;
            }else if(uniformSpeakerInfoId !== speakerInfoId){
                return null;
            }
        }

        return speakerInfoInitialized ? uniformSpeakerInfo : null;
    },

    canSpeakerBeChangedForSequencerNode : function(sequencerNode){
        const audioSegment = sequencerNode && sequencerNode.getAudioSegment ? sequencerNode.getAudioSegment() : null;
        return !!(audioSegment && typeof audioSegment.setSpeakerInfo === "function");
    },

    getVisibleSequencerNodesSelected : function(arrayOfSequencerNodes, options){
        const normalizedOptions = options || {};
        return (arrayOfSequencerNodes || []).filter((sequencerNode)=>{
            return normalizedOptions.isSequencerNodeVisible ? normalizedOptions.isSequencerNodeVisible(sequencerNode) : true;
        });
    },

    selectionContainsEligibleSpeakerChangeAnchor : function(arrayOfSequencerNodes, options){
        const normalizedOptions = options || {};
        return (arrayOfSequencerNodes || []).some((sequencerNode)=>{
            return !!(
                sequencerNode
                && (
                    (sequencerNode.needToBeAssociactedWithASpeaker && sequencerNode.needToBeAssociactedWithASpeaker())
                    || this.getEffectiveSpeakerInfoForSequencerNode(sequencerNode, normalizedOptions)
                )
            );
        });
    },

    isSpeakerChangeForSelectionAvailableForNodes : function(arrayOfSequencerNodes, options){
        if(!arrayOfSequencerNodes || arrayOfSequencerNodes.length === 0){
            return false;
        }

        const normalizedOptions = options || {};
        const visibleSequencerNodesSelected = this.getVisibleSequencerNodesSelected(arrayOfSequencerNodes, normalizedOptions);
        if(visibleSequencerNodesSelected.length === 0){
            return false;
        }

        const allVisibleNodesAreEligible = visibleSequencerNodesSelected.every((sequencerNode)=>{
            return this.isVisibleSequencerNodeEligibleForSpeakerChange(sequencerNode, normalizedOptions)
                && this.canSpeakerBeChangedForSequencerNode(sequencerNode);
        });

        if(!allVisibleNodesAreEligible){
            return false;
        }

        return this.selectionContainsEligibleSpeakerChangeAnchor(visibleSequencerNodesSelected, normalizedOptions);
    },

    getSpeakerInfoOptionsForTarget : function(speakerChangeTarget, arrayOfSpeakerInfo, options){
        const normalizedOptions = options || {};
        const selectedSpeakerInfoId = (normalizedOptions.getSpeakerInfoId || getSpeakerInfoId)(
            speakerChangeTarget ? speakerChangeTarget.currentSpeakerInfo : null,
        );

        return (arrayOfSpeakerInfo || []).reduce((speakerInfoToDisplay, speakerInfo)=>{
            const speakerInfoId = (normalizedOptions.getSpeakerInfoId || getSpeakerInfoId)(speakerInfo);
            if(!selectedSpeakerInfoId || speakerInfoId !== selectedSpeakerInfoId){
                speakerInfoToDisplay.push(speakerInfo);
            }
            return speakerInfoToDisplay;
        }, []);
    },
};

module.exports = SelectionSpeakerChangeHelper;
